export const stringToColor = string => {
	let hash = 0;
	for (let i = 0; i < string.length; i++) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}

	const h = hash % 360;
	const s = 70 + (hash % 30); // Saturation between 70% and 100%
	const l = 50 + (hash % 20); // Lightness between 50% and 70%

	return `hsl(${h}, ${s}%, ${l}%)`;
};
